import React, { Component } from 'react'; //different
//import './style.css';
import MainSettingContext from './MainSettingContext';
import instance from "./axios-instance";
import { getMainSettingCached } from "./sharedApi";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import "react-toastify/dist/ReactToastify.css";
class App extends Component {
    static contextType = MainSettingContext;

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            lang: window.localStorage.getItem("lang"),
            bankselect: 0,
            trueaccount: true,
            checknameOn: null, // [2026-10-31] เว็บนี้เปิดเช็คชื่อบัญชีไหม (null = ยังไม่รู้)
            username: null,
            tblbank: [],
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: "",
            logoimg: "",
            linelink: "",
            balance: 0,
            mainacc: null,
            acceptTerms: false,
            showTerms: false,
            phoneErr: "",
        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }
    notify = (mode, msg) => {
        Swal.fire({
            title: mode + '!',
            text: msg,
            icon: mode,
            confirmButtonText: 'ตกลง'
        })

    }

    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input === 99) {
            this.setState({
                trueaccount: false
            });
        }
        else if (this.state.checknameOn === false) {
            // [2026-10-31] เว็บไม่ได้เปิดเช็คชื่อ → ให้พิมพ์ชื่อเองได้เลย (ไม่ล้างชื่อที่พิมพ์ไว้)
            this.setState({ trueaccount: false });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }

    // [2026-10-31] ถามหลังบ้านครั้งเดียวว่าเปิดเช็คชื่อบัญชีไหม — ปิด = ช่องชื่อพิมพ์ได้ตั้งแต่แรก
    probeCheckname = async () => {
        try {
            const res = await instance.post("/api/v1/resetpassword", { System: Systems, type: 10, probe: 1 });
            const m = res && res.data && res.data.message;
            if (m && m.checkname === false) this.setState({ checknameOn: false, trueaccount: false });
            else if (m && m.checkname === true) this.setState({ checknameOn: true });
        } catch (e) { /* ใช้แบบเดิม */ }
    }
    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;

            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt,
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;

            });
        }
        return recheck
    }
    componentDidUpdate(prevProps, prevState) {
        const { userrecomend } = this.props; // destructuring for easier access

        // Check if point has changed (อย่าให้ prop ว่างมาทับค่าที่ resolve จาก reg แล้ว)
        if (prevProps.userrecomend !== userrecomend) {
            if (userrecomend && userrecomend !== this.state.userrecomend) {
                console.log("componentDidUpdate - point updated:", userrecomend);
                this.setState({ userrecomend });
            }
        }

    }
    // ตัวบอกขั้นตอนสมัคร (แบบ solomon168): สมัครสมาชิก / ตั้งรหัสผ่าน / บัญชีธนาคาร
    renderRegSteps = (active) => {
        const steps = [
            { label: 'สมัครสมาชิก', icon: <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" /> },
            { label: 'ตั้งรหัสผ่าน', icon: <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" /> },
            { label: 'บัญชีธนาคาร', icon: <path d="M8 .95 14.61 4h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.379l.5 2A.5.5 0 0 1 15.5 17H.5a.5.5 0 0 1-.485-.621l.5-2A.5.5 0 0 1 1 14V7H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 4h.89L8 .95zM3.5 7v7h1V7h-1zm3 0v7h1V7h-1zm3 0v7h1V7h-1zm3 0v7h1V7h-1z" /> },
        ];
        return (
            <div className="sreg-head">
                <h2 className="sreg-title">สมัครสมาชิก</h2>
                <div className="sreg-steps">
                    <div className={"sreg-line l1" + (active > 1 ? " done" : "")} />
                    <div className={"sreg-line l2" + (active > 2 ? " done" : "")} />
                    {steps.map((s, i) => (
                        <div key={i} className={"sreg-step" + (i + 1 <= active ? " active" : "")}>
                            <div className="sreg-dot">
                                {i + 1 < active
                                    ? <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" viewBox="0 0 16 17">{s.icon}</svg>}
                            </div>
                            <div className="sreg-lb">{s.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    nextstep = async (e, num) => {
        e.preventDefault();
        const { stateregis, password, bankselect, passwordcf, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state
        console.log(5565656, num);
        if (num === 1) {
            const check = await this.forgetotpandregister(6);

            console.log(phoneNumber.length === 10 && check.checked)
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
                }
                else {
                    await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรดรอซักครู่');
                    this.setState({
                        stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่"
                    });
                }
            }
        }
        else if (num === 2) {

            if (password !== passwordcf) {
                await this.notify("warning", 'คุณไส่พาสเวิดไม่ตรงกัน');
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }

        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน');
                //////console.log(2, stateregis, checkboxacc);
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

            else {
                await this.notify("warning", 'รหัสผิดพลาด');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }

        }
        else if (num === 11) {

            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            //////console.log(1, stateregis, num);
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
                var title = 'error'
                var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
                var object = { title, text }
                this.modalerror(object);

            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });
                if (fname === '' && this.state.checknameOn === false) {
                    var title = 'error'
                    var text = 'กรุณากรอกชื่อ-นามสกุลของบัญชี'
                    var object = { title, text }
                    this.modalerror(object);
                    try { document.getElementById("fname").focus(); } catch (er) { }
                }
                else if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);
                        if (check.verifications.status === 0) {
                            // ดึงชื่อจากธนาคารไม่ได้ → เปิดให้พิมพ์ชื่อเอง + บอกลูกค้า
                            this.setState({
                                trueaccount: false,
                            });
                            var title = 'warning'
                            var text = 'กรุณากรอกชื่อ-นามสกุลของบัญชี แล้วกดยืนยันอีกครั้ง'
                            var object = { title, text }
                            this.modalerror(object);
                            try { setTimeout(() => document.getElementById("fname").focus(), 300); } catch (er) { }
                        }
                        else if (check.verifications.status === 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = 'เลขบัญชีไม่ถูกต้อง'
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }
                this.setState({
                    loading: false,
                });
                //console.log(302, check.verifications);
            }

        }
    };

    onChangex = event => {
        // console.log("event", event.target.name);

        if (event.target !== undefined) {
            let nam;
            let val;
            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }
            this.setState({ [nam]: val });
        }
    };
    async modalerror(object) {
        // await Swal.fire({
        //     title: object.title + "!",
        //     text: object.text,
        //     icon: object.title,
        //     confirmButtonText: 'ตกลง'
        // })
        await this.notify(object.title, object.text);
    }
    validatergisterForm = async (e, fname) => {
        e.preventDefault();
        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        console.log(bankselect);
        console.log(this.state)
        if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
            var title = 'error'
            var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (fname === "") {

            var title = 'error'
            var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล'
            var object = { title, text }
            this.modalerror(object);

        }
        else if (password.length > 15) {
            var title = 'error'
            var text = 'พาสเวิดสูงสุดไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password.length < 6) {
            var title = 'error'
            var text = 'พาสเวิดต่ำไม่เกิน 15 ตัว'
            var object = { title, text }
            this.modalerror(object);
        }
        else if (password != passwordcf) {
            var title = 'error'
            var text = 'รหัสยิืนยันไม่ตรงกัน'
            var object = { title, text }
            this.modalerror(object);
        }
        else {
            // กันพลาด (race ตอนโหลดครั้งแรก): ไล่หาผู้แนะนำ state -> localStorage -> resolve reg ซ้ำ
            let refer = this.state.userrecomend;
            if (!refer) {
                try {
                    const a = JSON.parse(localStorage.getItem('aff') || 'null');
                    if (a && a.username) refer = a.username;
                } catch (e) { /* ignore */ }
            }
            if (!refer) {
                const regparam = this.regParam || (window.location.href.split("reg=")[1] || "").split("&")[0];
                if (regparam) {
                    try {
                        const rr = await instance.post("/api/v1/saveclickaff", { linkid: regparam, System: Systems });
                        if (rr.data && rr.data.status === 200 && rr.data.username) {
                            refer = rr.data.username;
                            this.setState({ userrecomend: refer });
                        }
                    } catch (e) { /* ignore */ }
                }
            }
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: refer
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                    var title = 'success'
                    var text = 'ทำการสมัครเรียบร้อย กรุณารอซักครู่'
                    var object = { title, text }
                    await this.modalerror(object);
                    await instance.post("/api/v1/userlogin", {
                        userid: phoneNumber,
                        password: password,
                        System: Systems,
                        Function: 'validateLoginForm-navbar.js'
                    }).then((res) => {
                        if (res.status === 200) {
                            if (res.data.status === 200) {
                                localStorage.setItem('auth_token', res.data.token);
                                setTimeout(() => // [2026-10-25] เดิม setInterval 1.5 วิ (วนซ้ำ) → setTimeout 0.6 วิ
                                    window.location.href = '/'
                                    , 600);

                            }
                        }
                    });
                }
                else if (res.data.status === 203) {
                    var title = 'error'
                    var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error'
                    var text = 'Username นี้ทำการสมัครไปแล้ว'
                    var object = { title, text }
                    this.modalerror(object);
                }
                else {
                    var title = 'error'
                    var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง'
                    var object = { title, text }
                    this.modalerror(object);
                }
            });
        }

    };
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    async saveclickaff(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                var date = new Date()
                this.setState({
                    userrecomend: res.data.username,
                    link: linkid
                });
                var username = res.data.username
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async saveclick(linkid) {
        await instance.post("/api/v1/saveclickaff", {
            linkid: linkid,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                var date = new Date()
                var username = res.data.username
                this.setState({
                    userrecomend: username,
                });
                var object = { date, username }
                localStorage.setItem('aff', JSON.stringify(object))
            }
        }).catch(async (err) => {
        });

    }
    async componentDidMount() {
        this.probeCheckname();
        // var token = localStorage.getItem('auth_token');
        // if (token != null) {
        //     localStorage.removeItem('auth_token', '')
        // }

        const search = window.location.href;
        var test = search.split("aff=")[1]
        if (test != undefined) {
            this.saveclickaff(test.split("&")[0]);
        }
        var params = search.split("reg=")[1]
        if (params != undefined) {
            // เก็บ md5 ไว้ใช้ตอนกดสมัคร (กัน URL เปลี่ยน/แคช)
            this.regParam = params.split("&")[0];
            // resolve reg (md5) -> username จริง ผ่าน saveclick เหมือน hengwin
            // (ไม่เซ็ต userrecomend เป็น md5 ดิบ เพราะ backend นับด้วย playerid)
            this.saveclick(this.regParam);
        }

        var tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            var codev = JSON.parse(tokenf)
            //   console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }

        var tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            var codev = JSON.parse(tokenx)
            // console.log(codev);
            var Username = codev.username;
            this.setState({
                userrecomend: Username,
            });
        }

        await getMainSettingCached() /* [2026-10-25] ร่วม request/cache กับ main.js (sharedApi) */.then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                var min = res.data.tblcatagoryx[0].limitdeposit;
                var max = res.data.tblcatagoryx[0].maxdeposit;
                var limit = { min, max }
                this.setState({
                    linelink: datas[1].value,
                    tblbank: res.data.tblbank,
                    logoimg: res.data.tblsetting[0].imglogo,
                    System: res.data.tblcatagoryx[0].System,
                    limit: limit
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        //  this.nameInput.focus();
    }

    render() {

        const { stateopterror, tblbank } = this.state
        return (
            <>
                <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                    {/**/}
                </div>
                <div className="-games-index-page col-12">
                    <div className="mb-2 text-white-v1">
                        <div className="d-none d-lg-block">
                        </div>
                        {/**/}
                        <div className="padding-router-view">
                            <div className="">
                                <div className=" m-3">
                                    <div className="container">
                                        <div className="row">
                                            <div className="pt-5 text-white-v1 text-center col col-sm-8 col-md-10 col-lg-8 col-xl-5 pl-0 pr-0 mx-auto my-auto">

                                                <br />
                                                <div className={"x-modal-separator-container x-login-form  bg-signIn neon-auth-box sreg-st" + this.state.stateregis}>
                                                    <div className="-top">
                                                        <div data-animatable="fadeInModal" className="animated fadeInModal"  >
                                                            <div className="text-font-title-signin text-white-v1 mt-2 pt-2">
                                                                <img
                                                                    src={this.state.logoimg}
                                                                    className="logo-w-signIn-v113"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="-img-container text-center">
                                                            </div>
                                                            {/**/}
                                                            <form autocomplete="new-password" style={{ marginTop: "-10px" }}>
                                                                <div className="x-modal-separator-container x-login-form pb-3  bg-signup">
                                                                    <div className="-top" style={{ display: this.state.stateregis === 1 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            {this.renderRegSteps(1)}
                                                                            <div className="sreg-phone-row">
                                                                                <input
                                                                                    onChange={(e) => { this.onChangex(e); if (this.state.phoneErr) this.setState({ phoneErr: "" }); }}
                                                                                    type="text"
                                                                                    id="phoneNumber"
                                                                                    name="phoneNumber"
                                                                                    className="sreg-input"
                                                                                    maxLength={10}
                                                                                    minLength={10}
                                                                                    aria-label="phoneNumber"
                                                                                    placeholder="กรอกเบอร์โทรศัพท์"
                                                                                />
                                                                                <button
                                                                                    ref={(input) => { this.nameInput = input; }}
                                                                                    onClick={(e) => { e.preventDefault(); e.persist && e.persist(); const el = document.getElementById('phoneNumber'); const v = el ? el.value.trim() : this.state.phoneNumber; if (!v) { this.setState({ phoneErr: 'กรุณากรอกข้อมูล' }); return; } if (!this.state.acceptTerms) { this.setState({ phoneNumber: v, phoneErr: '' }); this.notify('warning', 'กรุณายอมรับเงื่อนไขการสมัครสมาชิก'); return; } this.setState({ phoneNumber: v, phoneErr: '' }, () => this.nextstep(e, 1)); }}
                                                                                    className="sreg-next">
                                                                                    <span id='menu184'>ถัดไป</span>
                                                                                </button>
                                                                            </div>
                                                                            {this.state.phoneErr && <div className="sreg-err">{this.state.phoneErr}</div>}
                                                                            <label className="sreg-terms">
                                                                                <input type="checkbox" checked={this.state.acceptTerms} onChange={(e) => this.setState({ acceptTerms: e.target.checked })} />
                                                                                <span>ยอมรับเงื่อนไขการสมัครสมาชิก <a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ showTerms: true }); }}>(อ่านเพิ่มเติม)</a></span>
                                                                            </label>
                                                                            {this.state.showTerms && (
                                                                                <div className="sreg-terms-ovl" onClick={(e) => { if (e.target === e.currentTarget) this.setState({ showTerms: false }); }}>
                                                                                    <div className="sreg-terms-box">
                                                                                        <div className="sreg-terms-head">
                                                                                            <span className="sreg-terms-x" role="button" onClick={() => this.setState({ showTerms: false })}>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="sreg-terms-title">เงื่อนไขการสมัครสมาชิก</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="-top" style={{ display: this.state.stateregis === 2 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            {this.renderRegSteps(2)}
                                                                            <div className="sreg-s2">
                                                                                <div className="sreg-pw">
                                                                                    <input onChange={this.onChangex} onBlur={() => this.setState({ pwTouched: true })} type={!this.state.showpass ? "text" : "password"} id="password" name="password" className={"sreg-pwinput" + (this.state.pwTouched && !this.state.password ? " err" : "")} placeholder="กรอกรหัสผ่าน" autoComplete="new-password" />
                                                                                    <span className="sreg-eye" role="button" onClick={(e) => this.changepass(e)}><svg style={{ display: (!this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" viewBox="0 0 16 16"><path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" /><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" /><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" /></svg><svg style={{ display: (this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" /><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" /></svg></span>
                                                                                </div>
                                                                                <div className="sreg-fb">{this.state.pwTouched && !this.state.password ? "กรุณากรอกข้อมูล" : ""}</div>
                                                                                <div className="sreg-pw">
                                                                                    <input onChange={this.onChangex} onBlur={() => this.setState({ pwcfTouched: true })} type={!this.state.showpass ? "text" : "password"} id="passwordcf" name="passwordcf" className={"sreg-pwinput" + (this.state.pwcfTouched && !this.state.passwordcf ? " err" : "")} placeholder="กรอกรหัสผ่านอีกครั้ง" autoComplete="new-password" />
                                                                                    <span className="sreg-eye" role="button" onClick={(e) => this.changepass(e)}><svg style={{ display: (!this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" viewBox="0 0 16 16"><path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" /><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" /><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" /></svg><svg style={{ display: (this.state.showpass) ? "none" : "" }} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="currentColor" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" /><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" /></svg></span>
                                                                                </div>
                                                                                <div className="sreg-fb">{this.state.pwcfTouched && !this.state.passwordcf ? "กรุณากรอกข้อมูล" : ""}</div>
                                                                                <div className="sreg-btnrow">
                                                                                    <button type="button" className="sreg-back" onClick={(e) => this.nextstep(e, 11)}><span id='menu187'>ย้อนกลับ</span></button>
                                                                                    <button type="button" className="sreg-setpw" disabled={!this.state.password || !this.state.passwordcf} onClick={(e) => this.nextstep(e, 2)}><span id='menu188'>ตั้งรหัสผ่าน</span></button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="-top" style={{ display: this.state.stateregis === 3 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            {this.renderRegSteps(3)}
                                                                            <div className="sreg-s3">
                                                                                <div className="sreg-tabs">
                                                                                    <div className="sreg-tab active"><span>บัญชีธนาคาร</span></div>
                                                                                </div>
                                                                                <div className="sreg-banks">
                                                                                    {tblbank.map((listitem, i) => (
                                                                                        <a key={i} role="button" className={"sreg-bank" + (this.state.bankselect == listitem.bank_id ? " sel" : "")} onClick={() => this.radiocheck(listitem.bank_id)} title={listitem.fullname_th}>
                                                                                            <img src={listitem.full_img || listitem.img_path} alt={listitem.acro || "bank"} />
                                                                                        </a>
                                                                                    ))}
                                                                                </div>
                                                                                <div className="sreg-selbank">{(tblbank.find((b) => b.bank_id == this.state.bankselect) || {}).fullname_th || "กรุณาเลือกบัญชีธนาคาร"}</div>
                                                                                <input onChange={this.onChangex} id="accnumbertxt" inputMode="numeric" name="accnumbertxt" className="sreg-field" aria-label="member_accid" placeholder="กรุณากรอกเลขบัญชี" />
                                                                                <input type="text" onChange={this.onChangex} id="fname" value={this.state.fname} name="fname" readOnly={this.state.trueaccount} className="sreg-field" aria-label="member_name" placeholder={this.state.trueaccount ? "ระบบจะดึงชื่อบัญชีให้อัตโนมัติ" : "กรุณากรอกชื่อ-นามสกุล"} />
                                                                                <div className="sreg-note">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 7v6M12 16.5v.5" strokeLinecap="round" /></svg>
                                                                                    <span>{this.state.trueaccount ? 'ระบบจะดึงชื่อบัญชีให้อัตโนมัติหลังกด "ยืนยันสมัครสมาชิก"' : 'กรุณากรอกชื่อ-นามสกุลของบัญชีให้ถูกต้อง เพื่อดำเนินการต่อ'}</span>
                                                                                </div>
                                                                                <div className="sreg-btnrow sreg-btnrow3">
                                                                                    <button type="button" className="sreg-back" onClick={(e) => this.nextstep(e, 11)}><span id='menu191'>ย้อนกลับ</span></button>
                                                                                    <button type="button" className="sreg-setpw" disabled={this.state.loading || !this.state.bankselect || !this.state.accnumbertxt} onClick={(e) => this.nextstep(e, 25)}>
                                                                                        {this.state.loading ? <span className="spinner-border spinner-border-sm" role="status" /> : <span id='menu192'>ยืนยันสมัครสมาชิก</span>}
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            <div className="sreg-foot">
                                                                {this.state.stateregis === 1
                                                                    ? <>มีบัญชีแล้ว <a href="/signin" onClick={(e) => { e.preventDefault(); window.location.href = '/signin'; }}>เข้าสู่ระบบ</a></>
                                                                    : <>พบปัญหา <a href={this.state.linelink} target="_blank" rel="noreferrer">ติดต่อฝ่ายบริการลูกค้า</a></>}
                                                            </div>
                                                            <div className="mt-3" style={{ display: "none" }}>
                                                                <div className="row m-0">
                                                                    <div className="col-6 col-md-6">
                                                                        <button className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                window.location.href = '/signin';
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-person-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                                                            </svg>
                                                                            <span><span id='menu194'>เข้าสู่ระบบ</span></span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6 col-md-6">
                                                                        <a href={this.state.linelink} className="btn -submit js-submit-accept-term btn-success v-login-contact mt-lg-1 mt-0 w-100 p-2">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-telephone-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                                                                                />
                                                                            </svg>
                                                                            <span><span id='menu195'>ติดต่อเรา</span></span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default App;
